'use client';

import Link from 'next/link';
import { Button, TextPassage } from '@petsmart-ui/sparky';
import { ColoredTextLink } from '../ColoredTextLink';
import { SECONDARY_BUTTON_STYLE, TARGET_BLANK } from '../../constants';
import type { FaqStoreCardProps } from './types';
import './FaqStoreCards.scss';

function FaqStoreCard({ cityState, address, badges, phoneNumber, cta }: FaqStoreCardProps) {
    return (
        <div className="faq-store-card">
            <ColoredTextLink
                className="faq-store-card__headline"
                href={cityState?.link?.webUrl ?? ''}
                color="Dark Grey"
            >
                {cityState.actionText}
            </ColoredTextLink>
            <div className="faq-store-card__text">
                <TextPassage>{address}</TextPassage>
                <ColoredTextLink href={`tel:${phoneNumber}`} color="Dark Grey">
                    {phoneNumber}
                </ColoredTextLink>
            </div>
            <div className="faq-store-card__badges">
                {badges?.map(({ text }, index) => (
                    <TextPassage className="faq-store-card__badge" size="sm" key={index}>
                        {text}
                    </TextPassage>
                ))}
            </div>
            {cta && (
                <Link prefetch={false} href={cta?.link?.webUrl ?? ''} target={TARGET_BLANK}>
                    <Button variant={SECONDARY_BUTTON_STYLE} text={cta.text} size="sm" />
                </Link>
            )}
        </div>
    );
}

export function FaqStoreCards({ answers }: { answers: FaqStoreCardProps[] }) {
    return (
        <li className="faq-store-cards">
            {answers.map((card, index) => (
                <FaqStoreCard key={index} {...card} />
            ))}
        </li>
    );
}
